import { cn } from '@/lib/utils';

function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cn('bg-muted relative overflow-hidden rounded-md', className)} {...props}>
      <div className="animate-shimmer via-foreground/5 absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent to-transparent" />
    </div>
  );
}

export { Skeleton };
